import * as PIXI from 'pixi.js';
import Element from '../../Prototype/UI/Element';
import UIComponent from './UIComponent';

export interface IMaskOffset {
    left: number;
    top: number;
    bottom: number;
    right: number;
}

export default class UIMaskComponent extends UIComponent {
    public UIComponent: PIXI.ui.component.Mask;

    public attach(gameObject: Element, params: any): void {
        this.UIComponent = new PIXI.ui.component.Mask({
            left: params.data.offset[0],
            top: params.data.offset[1],
            right: params.data.offset[2],
            bottom: params.data.offset[3],
        });

        gameObject.container.add(this.UIComponent);

        super.attach(gameObject, params);
    }

    public enabled: boolean = true;
    public offset: IMaskOffset = {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
    };
}
